import { logger } from '@fiverr-private/obs';
import pathfinder from '@fiverr-private/pathfinder';
import { type CustomAxiosConfig, maxios } from '../../lib/maxios/maxios';

export const deleteStoreData = async (storeId: string) => {
    const url = pathfinder('ai_store_builder_api_delete', {
        version: 'v1',
        store_id: storeId,
    });

    const options: Partial<CustomAxiosConfig> = {
        routeKey: 'delete_store_data',
    };

    try {
        await maxios.delete(url, options);
    } catch (error) {
        logger.error(error as Error, {
            description: 'Failed to delete store data',
            store_id: storeId,
        });
    }
};
